import { render } from "./platformTable.vue?vue&type=template&id=66339aa2&scoped=true"
import script from "./platformTable.vue?vue&type=script&lang=js"
export * from "./platformTable.vue?vue&type=script&lang=js"

import "./platformTable.vue?vue&type=style&index=0&id=66339aa2&scoped=true&lang=css"

import exportComponent from "E:\\Apangu\\TdServerMiniAppPortalWeb\\TdServerMiniAppPortalWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66339aa2"]])

export default __exports__